var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36536,
    cy: 10.7333,
    r: 8.33333,
    className: "fill-bg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58204 1.66699C7.85145 1.66699 6.15973 2.18017 4.7208 3.14163C3.28187 4.1031 2.16036 5.46966 1.49809 7.06851C0.835822 8.66737 0.662543 10.4267 1.00016 12.124C1.33778 13.8214 2.17114 15.3805 3.39485 16.6042C4.61856 17.8279 6.17766 18.6612 7.875 18.9989C9.57233 19.3365 11.3317 19.1632 12.9305 18.5009C14.5294 17.8387 15.8959 16.7172 16.8574 15.2782C17.8189 13.8393 18.332 12.1476 18.332 10.417C18.332 8.09635 17.4102 5.87075 15.7692 4.22981C14.1283 2.58886 11.9027 1.66699 9.58204 1.66699ZM9.58204 17.917C8.09868 17.917 6.64863 17.4771 5.41526 16.653C4.18189 15.8289 3.2206 14.6576 2.65294 13.2871C2.08528 11.9167 1.93676 10.4087 2.22615 8.95381C2.51553 7.49896 3.22984 6.16259 4.27873 5.11369C5.32763 4.0648 6.664 3.35049 8.11886 3.0611C9.57372 2.77171 11.0817 2.92024 12.4522 3.4879C13.8226 4.05555 14.9939 5.01685 15.8181 6.25022C16.6422 7.48358 17.082 8.93363 17.082 10.417C17.082 12.4061 16.2919 14.3138 14.8853 15.7203C13.4788 17.1268 11.5712 17.917 9.58204 17.917Z",
    fill: "#3E6E9C",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.b05d8bb303efb14f5cb72ff07f967783.svg";
export { ForwardRef as ReactComponent };